<template lang="pug">
  .page.page-thesis.stop-scrolling
    .container-fluid
      .row
        .col-sm-3.text-left.pt-5.thesis-side
          span.tag.k-talk NYU IDM Thesis · 2019
          h5.mt-3 {{ $t('thesis.subtitle') }}
          h1 {{ $t('thesis.projectTitle') }}
          p {{ $t('thesis.description') }}
          p {{ $t('thesis.goal') }}
          br
          a.btn.btn-secondary(href="https://www.youtube.com/watch?v=V32BcSGfJUk" target="_blank") {{ $t('thesis.buttons.midterm') }}
          //- br
          //- br
          //- a.btn.btn-secondary(href="https://docs.google.com/document/d/1aBBxB2LtJBwy-D9WFnjrVTo9xy54mTxnAAT7VV6M5KM/edit?usp=sharing", target='_blank') Latest Thesis Draft
          br
          br
          a.btn.btn-secondary(href="https://www.youtube.com/watch?v=iclQBGiTfiQ" target="_blank") {{ $t('thesis.buttons.final') }}
         
          br
          br
          a.btn.btn-secondary(href="https://cheyuwu.wordpress.com" target="_blank") {{ $t('thesis.buttons.updateLogs') }}
          
        .col-sm-9
          //- 2026-08-10: restored from a blank frame. The sketch is p5 *global mode*
          //-   (full-window canvas, createCapture, window-positioned buttons), so it
          //-   runs in its own document rather than mounted into the SPA.
          //-   Broke on 2025-02-26 when the Vite/Vue 3 migration replaced
          //-   p5-vue-mirror with a stub that ignored :scriptFiles.
          .thesis-stage
            iframe.thesis-frame(
              :src="sketchUrl",
              title="Intuitive Music Expression — interactive sketch",
              allow="camera; microphone; midi",
              loading="lazy")
            .thesis-hint {{ $t('thesis.hint') }}
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  setup() {
    const { t } = useI18n()
    return { t }
  },
  data(){
    return {
      sketchUrl: '/static/thesis/'
    }
  }
}
</script>
<style lang="sass">
.page-thesis
  min-height: calc(100vh - 200px)
  overflow: hidden
  .thesis-side
    padding-left: max(24px, calc((100vw - var(--content-w)) / 2))
    h2
      font-family: var(--font-display)
      font-size: 1.9rem
      margin: 6px 0 14px
    p
      color: var(--ink-2)
      line-height: 1.7
  .btn.btn-secondary
    background: var(--tint-2)
    border: 0
    color: var(--ink-2)
    border-radius: var(--r-pill)
    padding: 8px 22px
    font-size: 0.95rem
    transition: var(--t-hover)
    &:hover
      background: var(--tint-3)
      color: var(--ink)
  .thesis-stage
    padding-right: max(24px, calc((100vw - var(--content-w)) / 2))
    @media (max-width: 768px)
      padding: 0 16px

  .thesis-frame
    display: block
    width: 100%
    height: calc(100vh - 160px)
    min-height: 420px
    border: 0
    background: var(--bg0)
    @media (max-width: 768px)
      height: 70vh

  .thesis-hint
    margin-top: 10px
    font-size: 0.82rem
    color: var(--ink-4)
    letter-spacing: 0.02em
    line-height: 1.6
</style>